module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify',
    function ($scope, ngDroUAA, ngDroUtilsNotify) {

        $scope.audits;
        // init ordering
        $scope.ordering = 'eventDate';
        $scope.reverse = true;

        var pageable = {
            pageNumber: 0,
            size: 100,
            sorting: 'auditEventDate',
            order: 'desc'
        };

        $scope.pageable_size = pageable.size;

        $scope.loadAudits = function () {
            ngDroUAA.Audit.findByPageable(pageable).then(function (response) {
                $scope.audits = response.data;
            });
        };

        $scope.changeOrdering = function () {
            $("#displayedCollection").fadeOut();

            ignoreLoadMore = false;

            pageable.order = pageable.order === 'desc' ? 'asc' : 'desc';
            pageable.pageNumber = 0;

            $scope.loadMore(true);
        };

        var ignoreLoadMore = false; // viene utilizzato si per evitare richieste multiple, sia per evitare richieste dopo che ho scaricato tutte le pagine disponibili
        $scope.loadMore = function (reset) {
            if (!ignoreLoadMore) {
                ignoreLoadMore = true; // per evitare richieste multiple mentre attendo una risposta
                ngDroUAA.Audit.findByPageable(pageable).then(function (response) {
                    ignoreLoadMore = false;
                    if (response.data.length === 0) {
                        ignoreLoadMore = true;
                        ngDroUtilsNotify.success(null,'jdro_audit.stop_paging');
                        $scope.hideLoadMore = true;
                    }
                    
                    $scope.audits = reset || !$scope.audits ? response.data.content : $scope.audits.concat(response.data.content);
                    pageable.pageNumber = pageable.pageNumber + 1;
                }).catch(function (err) {
                    ignoreLoadMore = false;
                    ngDroUtilsNotify.error(null,'jdro_audit.error.find_all',null,err);
                }).finally(function () {
                    $("#displayedCollection").fadeIn();
                });
            }
        };

        /*
         * Init
         */
        // $scope.loadMore(); //Fatto nel template
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/audit/auditList/auditListCtrl.js
// module id = 417
// module chunks = 0